import { render, staticRenderFns } from "./AllGoods.vue?vue&type=template&id=431aaa28"
import script from "./AllGoods.vue?vue&type=script&lang=js"
export * from "./AllGoods.vue?vue&type=script&lang=js"
import style0 from "./AllGoods.vue?vue&type=style&index=0&id=431aaa28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports